import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import {useTranslation} from "react-i18next";
import {Consts} from "../pages/consts";

const SortAndAddNewTest = ({labTests, handleSortChange, setAddLabTest, sortConfig}) => {
  const { t: t } = useTranslation();

  const sortOptions = [
    { value: Consts.TEST_DATE, label: t("date") },
    { value: Consts.LAB_TEST_NAME, label: t("laboratory_test") },
  ];

  return (
    <div className="w3-row w3-padding-small">
      <div className="w3-col s2">
        {labTests?.length > 0 && (
          <label className="w3-right w3-padding-small w3-right">
            {t("sort_by")}:
          </label>
        )}
      </div>
      <div className="w3-col s6">
        {labTests?.length > 0 && (
          <div className="flex-aligned-items">
            <Select
              onChange={(selectedOption) =>
                handleSortChange(selectedOption?.value)
              }
              value={sortOptions?.find(
                (option) => option?.value === sortConfig?.key,
              )}
              options={sortOptions}
              placeholder={t("select")}
              className="custom-select"
              classNamePrefix="custom-select"
            />
            <FontAwesomeIcon
              onClick={() => handleSortChange(sortConfig?.key)}
              icon={sortConfig?.ascending ? faSortUp : faSortDown}
              className="w3-left w3-padding-small"
            />
          </div>
        )}
      </div>
      <div className="w3-col s4 w3-right">
        <div className="w3-padding-small">
          <button
            type="button"
            onClick={() => setAddLabTest(true)}
            className="w3-btn w3-round-xlarge w3-theme-d5 w3-right responsive-button"
          >
            + {t("add_new_laboratory_test_data")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SortAndAddNewTest;